// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"CobuTooltip_tooltip__1C4Q9"};